/**
 * Znajduje ID zmiennej w edition2 na podstawie ID z edition1
 * @param {number} variableIdFromEdition1 - ID zmiennej z edition1
 * @param {Array} displayTopics - Topics z trybu porównania (zawierają common_key_variables)
 * @param {Array} topicsEdition1 - Topics z edition1 (do mapowania po internal_id/name)
 * @param {Array} topicsEdition2 - Topics z edition2 (do mapowania po internal_id/name)
 * @returns {number|null} - ID zmiennej w edition2 lub null
 */
export function findEdition2VariableId(variableIdFromEdition1, displayTopics, topicsEdition1, topicsEdition2) {
   if (!variableIdFromEdition1 || !displayTopics) return null;
   
   const valueNum = Number(variableIdFromEdition1);
   
   // Najpierw sprawdź czy są common_key_variables w displayTopics
   for (let t of displayTopics) {
      const commonVars = t.common_key_variables || [];
      const mapped = commonVars.find(kv => Number(kv.edition1) === valueNum);
      if (mapped) {
         return mapped.edition2;
      }
      if (!!t.children?.length) {
         for (let c of t.children) {
            const childCommonVars = c.common_key_variables || [];
            const childMapped = childCommonVars.find(kv => Number(kv.edition1) === valueNum);
            if (childMapped) {
               return childMapped.edition2;
            }
         }
      }
   }
   
   // Jeśli nie znaleziono w common_key_variables, użyj mapowania po internal_id lub name
   if (!topicsEdition1 || !topicsEdition2) return null;
   
   // Znajdź zmienną w edition1
   let variableFromEdition1 = null;
   for (let t of topicsEdition1) {
      const found = t.keyVariables?.find(k => Number(k.id) === valueNum);
      if (found) {
         variableFromEdition1 = found;
         break;
      }
      if (t.children) {
         for (let c of t.children) {
            const childFound = c.keyVariables?.find(k => Number(k.id) === valueNum);
            if (childFound) {
               variableFromEdition1 = childFound;
               break;
            }
         }
         if (variableFromEdition1) break;
      }
   }
   
   if (!variableFromEdition1) return null;
   
   // Znajdź odpowiednią zmienną w edition2 po internal_id lub name
   for (let t of topicsEdition2) {
      const found = t.keyVariables?.find(k => 
         (k.internal_id && k.internal_id === variableFromEdition1.internal_id) ||
         (!k.internal_id && k.name === variableFromEdition1.name)
      );
      if (found) {
         return found.id;
      }
      if (t.children) {
         for (let c of t.children) {
            const childFound = c.keyVariables?.find(k => 
               (k.internal_id && k.internal_id === variableFromEdition1.internal_id) ||
               (!k.internal_id && k.name === variableFromEdition1.name)
            );
            if (childFound) {
               return childFound.id;
            }
         }
      }
   }
   
   return null;
}
